export default __webpack_public_path__ + "static/media/logo-guider-admin.577a8eb7.svg";